import { createVNode as n, mergeProps as s } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/EnterpriseUserManageFilledStandard.js";
import o from "../components/PfIcon.js";
const r = (e, t) => {
  const a = {
    ...e,
    ...t.attrs
  };
  return n(o, s(a, {
    icon: i
  }), null);
};
r.displayName = "EnterpriseUserManageFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
